/* eslint-disable react/jsx-props-no-spreading */
import { StrictMode, useEffect, useMemo, useRef, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import type { AppProps } from 'next/app';
import { Provider as StoreProvider } from 'unistore/react';
import { checkDocument } from '@buyhatke/custom-lib-js';
import { useRouter } from 'next/router';

import { Layout } from '@appComponents/Wrappers';
import { store } from '@utils/store';
import { ToastContext, toastNotify } from '@utils/contexts/toasts';

import '../src/styles/tailwind/styles.css';
import { i18next } from '@utils/i18next';
import {
	getGlobalParams,
	// getSwapCoinsParams,
	updateAppParams,
	initAppParamsApi,
} from '@utils/params';
import { coinsActions } from '@utils/store/coins';

function MyApp({
	Component,
	pageProps,
	data: { r1 /* r2 */ } = {
		r1: null,
		// r2: null,
	},
}: AppProps & {
	data?: {
		r1: AsyncReturnType<typeof getGlobalParams>;
		// r2: AsyncReturnType<typeof getSwapCoinsParams>;
	};
}) {
	// const [store, setStore] = useState<Store<unknown>>();

	useRef(() => {
		if (r1) {
			const ret = updateAppParams(r1, { status: 1, data: {} });
			store.action(coinsActions.__getAllCoins)(ret);

			return true;
		}
		return false;
	});

	const [ready, setReady] = useState(false);

	useEffect(() => {
		if (/* !apiDone &&  */ !ready) {
			initAppParamsApi()
				.then(res => {
					store.action(coinsActions.__getAllCoins)(res);

					setReady(true);
					// import('@utils/store').then(res => {
					// 	setStore(res.store);

					// });
				})
				.catch(console.log);
		}
	}, [/* apiDone,  */ ready]);

	const { asPath } = useRouter();

	useMemo(() => {
		// using this for triggering before render
		switch (true) {
			case asPath === '/tr' || asPath.startsWith('/tr/'): {
				i18next.changeLanguage('tr').catch(console.log);
				break;
			}
			default: {
				i18next.changeLanguage('en').catch(console.log);
			}
		}
	}, [asPath]);

	return (
		<StrictMode>
			<I18nextProvider i18n={i18next}>
				<ToastContext.Provider value={toastNotify}>
					<StoreProvider store={store}>
						<Layout>
							<Component {...pageProps} />
						</Layout>
					</StoreProvider>
				</ToastContext.Provider>
			</I18nextProvider>
		</StrictMode>
	);
}

export default MyApp;

let doneOnce = false;

MyApp.getInitialProps = async () => {
	if (doneOnce) {
		return {};
	}
	doneOnce = true;
	const {
		status,
		data: {
			masterCryptoTransferDisable,
			disableDepoNw,
			disableWithdNw,
			withLimits,
			coins,
			balanceCoins,
			depositCoins,
			withdrawCoins,
			inrCoins,
			usdtCoins,
			networkTypes,
			tryCoins,
		},
	} = (await getGlobalParams(checkDocument ? undefined : 'full')) as {
		status: 1;
		data: Record<string, unknown>;
	};

	const onlyReqData = {
		status,
		data: {
			masterCryptoTransferDisable,
			disableDepoNw,
			disableWithdNw,
			withLimits,
			coins,
			balanceCoins,
			depositCoins,
			withdrawCoins,
			inrCoins,
			tryCoins,
			usdtCoins,
			networkTypes,
		},
	};

	return {
		data: {
			r1: onlyReqData,
			// r2: (await getSwapCoinsParams(
			// 	checkDocument ? undefined : 'full'
			// )) as unknown,
		},
	};
};
